import { useState, useEffect, useContext, useMemo } from "react";
import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import { ChapterList } from "../../shared/domain/learning/components/ChapterList.jsx";
import { GlobalContext } from "../../context/GlobalState.jsx";
import { decodeHTMLEntities, cleanURLPath } from "../../shared/utils/url.js";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";

export default function AssessmentChapter(props) {
  const history = useHistory();
  const params = useParams();
  const { userDetails, setUserDetails, gradeSection } =
    useContext(GlobalContext);

  const subjectId = props?.match?.params?.subjectId;
  const [pageData, setPageData] = useState({
    chapters: [],
    loading: true,
  });
  const { chapters, loading } = pageData;
  const selectedSubject = useMemo(() => {
    return params["subjectName"] || "Chapters";
  }, [params]);

  function openChapter(chapter) {
    history.push(
      `${window.location.pathname}/${chapter._id}/${decodeHTMLEntities(
        cleanURLPath(chapter.name),
      )}`,
    );
  }

  useEffect(() => {
    if (!subjectId) return;
    fetch(`${process.env.REACT_APP_ORIGIN}/api/v1/subjects/${subjectId}`, {
      headers: {
        token: `${window.localStorage.getItem("authToken")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        let chapters = response?.data?.subject?.totalChapters
          ? response?.data?.subject?.chapters.filter(
              (item) => item?.lang === window.localStorage.getItem("language"),
            )
          : [];
        setPageData((data) => ({
          ...data,
          loading: false,
          chapters: chapters || [],
        }));
      })
      .catch((e) =>
        setPageData((data) => ({
          ...data,
          loading: false,
        })),
      );
  }, []);

  useEffect(() => {
    setUserDetails({ ...userDetails, selectedTab: "My Assessment" });
    setUserDetails({
      ...userDetails,
      selectedPath: {
        subject: selectedSubject,
        chapter: "",
        topic: "",
      },
    });
  }, []);

  return (
    <LearningContentLayout
      grade={gradeSection}
      page={"Practice Assessment"}
      resourcePage={`${selectedSubject}`}
    >
      <ChapterList
        chapters={chapters}
        loading={loading}
        onClick={openChapter}
      />
    </LearningContentLayout>
  );
}
